import React, { useEffect } from 'react'
import styled from '@emotion/styled';
import { Box, Button, Container, Divider, Grid } from '@mui/material';
import Heading from '../../Components/Heading';
import Paragraph from '../../Components/Paragraph';
import free from '../../../assets/free.svg';
import monthly from '../../../assets/monthly.png';
import yearly from '../../../assets/yearly.png';
import Global from '../../../assets/Global.png';
import Lock from '../../../assets/lock.png';
import wifi from '../../../assets/wifi.png';
import layerbg from '../../../assets/layerbg.png';
import Military from '../../../assets/Military.png';
import speed from '../../../assets/speed.png';
import No from '../../../assets/No.png';
import Cardtitle from '../../Components/CardTitle';
import yeartop from '../../../assets/yeartop.png';
import PurpleButton from '../../Components/PurpleButton';
import { useNavigate } from 'react-router-dom';
import Aos from 'aos';

const LayerImage = styled.img`
    position: absolute;
    top: 10px;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; 
    pointer-events: none; 
    z-index: -1; 
    @media (max-width: 600px) {
    display: none;
  }
`;
const BlackButton = styled(Button)`
text-transform: none;
color: white;
font-family: "PoppinsM";
width: fit-content;
border-radius: 40px !important;
font-size:14px;
font-family: Bold !important;
padding:${(props) => (props.p ? props.p : "2px 10px")};
border: 3px solid #000000f0;
cursor: not-allowed;
&:hover{
background: linear-gradient(9deg,#43404d 30%,#8d8994); 
  color: white;
}
@media(max-width: 599px){
font-size: 14px !important;
padding: 7px 9px !important;
    }
`;

const UpperBox = styled(Box)`
background: linear-gradient(39deg,#43404d 10%,#8d8994); 
padding: 2px;
border-radius: 40px;
width: max-content;
`;
const Wrapper = styled(Box)`
  padding: 120px 0px;
  z-index: 0;
  position: relative;
     @media (max-width: 600px) {
     padding: 20px 0px;
  }
`;
const PricingCard = styled(Box)`
  background: #080411;
  border-radius: 16px;
  padding: 30px;
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid #222222;
  display: flex;
  flex-direction: column; 
  z-index: 99;
  position: relative;
  overflow: hidden;
`;

const TopRightBadge = styled.img`
  position: absolute;
  top: 0;
  right: 0px;
   width: 100%;
   height: auto;
  z-index: -1;
  pointer-events:none ;
`;
const IconWrapper = styled(Box)`
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 24px;
`
const FontSizes = styled('span')`
font-size: 27px;
@media(max-width: 599px){
        font-size: 17px;
    }
`

const Pricing = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    Aos.init({
      duration: 1200,
      offset: 100,
      once: false, 
      easing: 'ease-out-cubic',
      mirror: false,
    });
  }, []);

  const handlePlanSelect = (plan) => {
    navigate('/createyouraccount', { state: { selectedPlan: plan } });
  };

  return (
    <Wrapper id='pricing'>
         <Container maxWidth='xl' >
               <Grid container  justifyContent={'center'} textAlign={'center'}> 
                   <Grid item>
                    <Heading style={{marginBottom:'20px'}} data-aos="fade-up" data-aos-once="false">
                        {' '}
                        <span style={{
                        background: "linear-gradient(128deg, rgb(255 255 255) 52%, rgb(168, 96, 255)) text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontWeight: 'bolder'
                        }}>
                      Pricing
                        </span>
                    </Heading>
                    <Paragraph data-aos="fade-up" data-aos-once="false" style={{maxWidth:'700px',marginTop:'30px'}}>Select from a variety of global locations and enjoy complete online privacy with our premium ad-free VPN.</Paragraph>
                </Grid>
                    <Grid container spacing={4} style={{justifyContent:'center',textAlign:'left',marginTop:'20px'}}>
                        <Grid item xs={12} md={4}>
                        <PricingCard  data-aos="fade-up" data-aos-once="false">
                            <IconWrapper>
                            <img src={free} alt='free' style={{ width: '53px', height: '53px' }} draggable='false'/>
                            </IconWrapper>
                            <Cardtitle>Free</Cardtitle>
                             <Divider  sx={{ marginInline: '-30px', borderBottomWidth: '1px',borderColor: '#222222',marginTop:'10px'}}></Divider> 
                            <Box style={{marginTop:'20px'}}>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'5px',}}>
                              <img src={Global} alt='global'/>5 Global Servers 
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'5px',marginTop:'25px'}}>
                              <img src={Lock} alt='global'/>Basic Encryption
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'5px',marginLeft:'6px',marginTop:'25px'}}>
                              <img src={No} alt='global'/>No Speed Boost
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'5px',marginLeft:'6px',marginTop:'25px'}}>
                              {/* <img src={wifi} alt='global'/>1 Device Only */}
                              &nbsp;
                            </Paragraph>
                            </Box>
                              <Divider  sx={{ marginInline: '-30px', borderBottomWidth: '1px',borderColor: '#222222',marginTop:'20px',marginBottom:"25px"}}></Divider> 
                              <Cardtitle style={{marginBottom:'30px',marginTop:'10px'}}>$0/<FontSizes>month</FontSizes></Cardtitle>
                              <PurpleButton href='https://remote.shadownode.org/window/ShadowNodeVPN_Windows-free.exe' target='blank'  style={{fontSize:'18px',padding:'5px 18px'}}>Download Now</PurpleButton>
                                 {/* <UpperBox>
                  <BlackButton style={{ padding: '8px 20px', fontSize: '15px' }}>
                    Download now
                  </BlackButton>
                </UpperBox> */}
                        </PricingCard>
                        </Grid>

                        <Grid item xs={12} md={4}>
                        <PricingCard data-aos="fade-up" data-aos-once="false">
                            <IconWrapper>
                            <img src={monthly} alt='free' style={{ width: '53px', height: '53px' }} draggable='false'/>
                            </IconWrapper>
                            <Cardtitle>Monthly</Cardtitle>
                             <Divider  sx={{ marginInline: '-30px', borderBottomWidth: '1px',borderColor: '#222222',marginTop:'10px'}}></Divider> 
                            <Box style={{marginTop:'20px'}}>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'5px',}}>
                              <img src={Global} alt='global'/>14 Global Servers
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'7px',marginTop:'25px'}}>
                              <img src={Military} alt='global'/>Military Grade Encryption
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'7px',marginLeft:'5px',marginTop:'25px'}}>
                              <img src={speed} alt='global'/>Unlimited Speed
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'7px',marginLeft:'5px',marginTop:'25px'}}>
                              <img src={wifi} alt='global'/>Connect Up to 5 Devices
                            </Paragraph>
                            </Box>
                              <Divider  sx={{ marginInline: '-30px', borderBottomWidth: '1px',borderColor: '#222222',marginTop:'20px',marginBottom:"25px"}}></Divider> 
                              <Cardtitle style={{marginBottom:'30px',marginTop:'10px'}}>$5/<FontSizes>month</FontSizes></Cardtitle>
                              <PurpleButton 
                               href='https://app.shadownode.org/Buy_svpn' target='_blank'
                                style={{fontSize:'18px',padding:'5px 18px'}}
                                // onClick={() => handlePlanSelect('monthly')}
                              >
                                Buy Now
                              </PurpleButton>
                                    {/* <UpperBox>
                  <BlackButton style={{ padding: '8px 20px', fontSize: '15px' }}>
                    Buy now
                  </BlackButton>
                </UpperBox> */}
                        </PricingCard>
                        </Grid>

                        <Grid item xs={12} md={4}>
                        <PricingCard data-aos="fade-up" data-aos-once="false">
                             <TopRightBadge src={yeartop} alt="Best Value" /> 
                            <IconWrapper>
                            <img src={yearly} alt='free' style={{ width: '53px', height: '53px' }} draggable='false'/>
                            </IconWrapper>
                            <Cardtitle>Yearly</Cardtitle>
                             <Divider  sx={{ marginInline: '-30px', borderBottomWidth: '1px',borderColor: '#222222',marginTop:'10px'}}></Divider> 
                            <Box style={{marginTop:'20px'}}>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'5px',}}>
                              <img src={Global} alt='global'/>14 Global Servers
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'7px',marginTop:'25px'}}>
                              <img src={Military} alt='global'/>Military Grade Encryption
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'7px',marginLeft:'5px',marginTop:'25px'}}>
                              <img src={speed} alt='global'/>Unlimited Speed
                            </Paragraph>
                            <Paragraph style={{display:'flex',alignItems:'center',gap:'7px',marginLeft:'5px',marginTop:'25px'}}>
                              <img src={wifi} alt='global'/>Connect Up to 5 Devices
                            </Paragraph>
                            </Box>
                              <Divider  sx={{ marginInline: '-30px', borderBottomWidth: '1px',borderColor: '#222222',marginTop:'20px',marginBottom:"25px"}}></Divider> 
                              <Cardtitle style={{marginBottom:'30px',marginTop:'10px'}}>$50/<FontSizes>year</FontSizes></Cardtitle>
                              <PurpleButton 
                              href='https://app.shadownode.org/Buy_svpn' target='_blank'
                                style={{fontSize:'18px',padding:'5px 18px'}}
                                // onClick={() => handlePlanSelect('yearly')}
                              >
                                Buy Now
                              </PurpleButton>
                                      {/* <UpperBox>
                  <BlackButton style={{ padding: '8px 20px', fontSize: '15px' }}>
                    Buy now
                  </BlackButton>
                </UpperBox> */}
                        </PricingCard>
                        </Grid>
                        
                    </Grid>
               </Grid>
         </Container>
    </Wrapper>
  )
}

export default Pricing